import { createFiltersActions } from '../utils';

export const ACTIONS_PREFIX = 'USERS_WITHOUT_COMPUTERS';

export const {
    updateFilters,
    applyFilters,
    resetApplyFilters,
    resetApplyFiltersSilently,
    rebuildApplyFilters,
    rebuildApplyFiltersSilently
} = createFiltersActions(ACTIONS_PREFIX);
